import React, { Component } from "react";
import {
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableRowColumn,
  Menu,
  Snackbar,
  CircularProgress,
} from "material-ui";
import Loading from "../Loading";
import { Link } from "react-router";
import {
  FormsyRadioGroup,
  FormsyRadio,
  FormsyText,
} from "formsy-material-ui/lib";
import Formsy from "formsy-react";
import Dropzone from "react-dropzone";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import deleteDefaultIcon from "../../images/delete_default.png";
import editDefaultIcon from "../../images/edit_default.png";
import importDefaultIcon from "../../images/import_default.png";
import AddNewDocumentType from "./AddNewDocumentType";
import companyListIcon from "../../images/company_list.png";
import backIcon from "../../images/back.png";
import checkedIcon from "../../images/checked.png";
import addArrowIcon from "../../images/add_arrow.png";
import editMailingTypeIcon from "../../images/edit_mailing_type.png";
import AddCompany from "./AddCompany";
import searchIcon from "../../images/search.png";

export default class ShowCompanyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message:
        "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
      open: false,
      responseMsg: "",
      employee: {
        name: "",
        email: "",
        empId: "",
      },
      companyData: {
        company: "",
        companyId: "",
        address: "",
        contactNumber: "",
        _id: "",
        employees: [],
      },
      employeeList: [],
      showToast: false,
      toastMsg: "",
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "75%",
        },
        zone: {
          width: "100%",
          height: "300px",
          border: "3px dashed #ebeff2",
        },
        activeZone: {
          width: "100%",
          height: "300px",
          border: "3px dashed green",
          backgroundColor: "Aquamarine",
        },
        zoneText: {
          textAlign: "center",
          fontSize: "2em",
        },
      },
      openDeleteConfirmPopup: false,
      currentSelectedRow: {},
      file: "",
      companyOpen: false,
      company: {},
      searchTextValue: "",
      searchText: "",
      isEmployeeEdit: false,
    };
    this.onDrop = this.onDrop.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.deleteButtonFormatter = this.deleteButtonFormatter.bind(this);
    this.editButtonFormatter = this.editButtonFormatter.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
  }

  onDrop(e) {
    if (e[0].name.toLowerCase().split(".")[1] === "csv") {
      this.setState({ file: e[0] });
    } else if (e[0].name) {
      this.setState({ message: `Incorrect File Type, expecting CSV` });
    } else {
      this.setState({
        message:
          "You can also upload employee detail list from a csv. Drag & Drop employee detail list CSV here.",
      });
    }
  }

  submitForm(data) {
    if (this.state.file) {
      this.setState({ isLoading: true });
      let formData = new FormData();
      let url =
        "/api/documentUpload/uploadUser?mailingTypeId=" +
        this.state.companyData.companyId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
        },
        body: formData,
      };
      formData.append("file", this.state.file);
      fetch(url, options)
        .then((response) => response.json())
        .then((json) => {
          this.setState({ response: json, isLoading: false, file: "" });
          this.getEmployeeList();
        });
    } else {
      alert("File error");
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    //this.getEmployeeList()
  }

  componentWillReceiveProps(props) {
    let { companyData } = this.state;
    if (Object.keys(props.companyData).length != 0) {
      companyData.company = props.companyData.company;
      companyData.companyId = props.companyData.companyId;
      companyData.address = props.companyData.address;
      companyData.contactNumber = props.companyData.contactNumber;
      companyData._id = props.companyData._id;
      companyData.employees = props.companyData.employees;
      this.setState({ companyData: companyData });
    } else {
      companyData.company = "";
      companyData.companyId = "";
      companyData.employees = [];
      this.setState({ companyData: companyData });
    }
  }

  addEmployee = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { employee, companyData } = this.state;
    var me = this;
    if (employee.name == "" && employee.email == "" && employee.empId) {
      alert("Employee Id, Name and Email should not be blank.");
    } else if (employee.empId == "") {
      alert("Employee Id should not be blank.");
    } else if (employee.name == "") {
      alert("Name should not be blank.");
    } else if (employee.email == "") {
      alert("Email should not be blank.");
    } else if (!re.test(String(employee.email).toLowerCase())) {
      alert("Please enter valid email.");
    } else {
      let url =
        "/api/payroll/addEmployee?companyId=" +
        this.state.companyData.companyId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(employee),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.notifyFormError(res, "Internal server error.");
          }
        })
        .then((json) => {
          if (json.message == "employee already exist.") {
            this.notifyFormError(json, "Employee is already exist.");
          } else {
            employee.name = "";
            employee.email = "";
            employee.empId = "";
            companyData.employees = json.employees;
            me.setState({
              employee: employee,
              showToast: true,
              toastMsg: json.message,
            });
            //me.getEmployeeList();
          }
        });
    }
  };

  editEmployee = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let { employee, companyData } = this.state;
    var me = this;
    if (employee.name == "" && employee.email == "" && employee.empId) {
      alert("Employee Id, Name and Email should not be blank.");
    } else if (employee.empId == "") {
      alert("Employee Id should not be blank.");
    } else if (employee.name == "") {
      alert("Name should not be blank.");
    } else if (employee.email == "") {
      alert("Email should not be blank.");
    } else if (!re.test(String(employee.email).toLowerCase())) {
      alert("Please enter valid email.");
    } else {
      let url =
        "/api/payroll/updateEmployee?companyId=" +
        this.state.companyData.companyId;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(employee),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) {
            return res.json();
          } else {
            this.notifyFormError(res, "Internal server error.");
          }
        })
        .then((json) => {
          if (json.message == "employee already exist.") {
            this.notifyFormError(json, "Employee is already exist.");
          } else {
            employee.name = "";
            employee.email = "";
            employee.empId = "";
            companyData.employees = json.employees;
            me.setState({
              employee: employee,
              showToast: true,
              toastMsg: json.message,
              isEmployeeEdit: false,
            });
            //me.getEmployeeList();
          }
        });
    }
  };

  updateCompanyData = (companyData) => {
    this.setState({ companyData: companyData });
  };

  getEmployeeList() {
    let url = `/api/payroll/companyData?companyId=` + companyData.companyId;
    let body = companyData;
    let options = {
      method: "GET",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        companyData.company = json.companyData.company;
        companyData.companyData = json.companyData.companyId;
        companyData.employees = json.companyData.employees;
        me.setState({ companyData: companyData });
      });
  }

  onCompanyEmployeeValue = (key, value) => {
    let { employee } = this.state;
    if (key == "name") {
      employee.name = value;
    } else if (key == "empId") {
      employee.empId = value;
    } else {
      employee.email = value;
    }
    this.setState({ employee: employee });
  };

  onChangeValue = (value) => {
    let { companyData } = this.state;
    companyData.company = value;
    this.setState({ companyData: companyData });
  };

  editCompany = () => {
    let { companyData } = this.state;
    var me = this;
    if (companyData.company == "") {
      alert("company should not be blank.");
    } else {
      let url = `/api/payroll/editCompany?companyId=` + companyData.companyId;
      let body = companyData;
      let options = {
        method: "POST",
        headers: {
          token: this.props.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(companyData),
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          if (json.message == "Company already exist.") {
            this.notifyFormError(json, "Company is already exist.");
          } else {
            companyData.company = json.companyData.company;
            companyData.companyData = json.companyData.companyId;
            companyData.employees = json.companyData.employees;
            me.setState({
              companyData: companyData,
              showToast: true,
              toastMsg: json.message,
            });
          }
        });
    }
  };

  notifyFormError(data, msg) {
    alert(msg);
  }

  deleteMailingTypeListUser = (row) => {
    this.setState({ currentSelectedRow: row, openDeleteConfirmPopup: true });
  };

  deleteConfirmPopupClick = () => {
    let { companyData, currentSelectedRow } = this.state;
    var me = this;
    let url = `/api/payroll/deleteEmployee?companyId=` + companyData.companyId;
    let body = currentSelectedRow;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    console.log("url------", url);
    console.log("options------", options);
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        console.log("json-----------", json);
        this.setState({
          currentSelectedRow: {},
          openDeleteConfirmPopup: false,
        });
        if (json.message == "Mailing type employee not exist.") {
          me.notifyFormError(json, "Mailing type employee is not exist.");
        } else {
          //me.getEmployeeList();
          companyData.employees = json.employees;
          me.setState({ companyData: companyData });
        }
      });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    console.log("searchText--------", searchText);
    if (searchText != "" && searchText != null) {
      this.props.navigation(
        this.state.companyData,
        "SHOW_COMPANY_DETAIL",
        searchText.trim(),
      );
      this.setState({ isLoading: false, searchTextValue: searchText.trim() });
    } else {
      this.setState({ searchTextValue: "" });
      this.props.navigation(this.state.companyData, "SHOW_COMPANY_DETAIL", "");
    }
  }

  deleteButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.deleteMailingTypeListUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <img src={deleteDefaultIcon} />
      </IconButton>
    );
  }

  editButtonFormatter(cell, row) {
    return (
      <IconButton
        onClick={() => {
          this.editMailingTypeListUser(row);
        }}
        style={{
          width: "25px",
          height: "25px",
          padding: "0px",
          paddingLeft: "15px",
        }}
      >
        <img src={editDefaultIcon} />
      </IconButton>
    );
  }

  editMailingTypeListUser = (row) => {
    let employee = {};
    employee.empId = row.empId;
    employee.name = row.name;
    employee.email = row.email;
    this.setState({ employee: employee, isEmployeeEdit: true });
  };

  clearSearchText() {
    this.setState({ searchTextValue: "" });
  }

  renderEmployeeTable = () => {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={"#424242"} />
          </center>
        </div>
      );
    } else {
      let { companyData } = this.state;
      console.log("companyData---------", companyData);
      return (
        <div
          className="mainTableCls"
          style={{ overflowY: "inherit", width: "95%", margin: "0 auto" }}
        >
          <div>
            <div>
              <div className="searchTextCls">
                <input
                  type="text"
                  value={this.state.searchTextValue}
                  className="searchInputCls"
                  placeholder="Search"
                  onChange={(e) => this.submitSearchForm(e.target.value)}
                />
                <span
                  className="searchImgCls"
                  onClick={(e) => {
                    this.clearSearchText();
                  }}
                >
                  <img src={searchIcon} style={{ width: "16px" }} />
                </span>
              </div>
            </div>
            <BootstrapTable
              data={companyData.employees}
              bordered={false}
              pagination
            >
              <TableHeaderColumn
                dataField="employeeId"
                width="100"
                isKey={true}
                hidden={true}
              ></TableHeaderColumn>
              <TableHeaderColumn dataField="name" width="100">
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataField="email" width="100">
                Email
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.editButtonFormatter}
                width="20"
              ></TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={this.deleteButtonFormatter}
                width="20"
              ></TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    }
  };

  showCompanyList = () => {
    this.setState({
      searchTextValue: "",
      isEmployeeEdit: false,
      employee: { name: "", empId: "", email: "" },
    });
    this.props.navigation({}, "SHOW_PAYROLL_CHECK", "");
  };

  handleToastClose = () => {
    this.setState({ showToast: false, toastMsg: "" });
  };

  renderContent() {
    let { response, isLoading } = this.state;
    let { zone, activeZone, centerStyle } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (isLoading) {
      let size = window.screen.width / 7;
      return <CircularProgress color={"#424242"} size={size} thickness={20} />;
    }
    return (
      <div style={{ padding: "2rem" }}>
        <Dropzone
          onDrop={this.onDrop}
          disablePreview={true}
          style={zone}
          activeStyle={activeZone}
        >
          <center>
            <h4 className="uploadAttachmentTextAlign">
              {this.state.file ? this.state.file.name : this.state.message}
            </h4>
          </center>
        </Dropzone>
      </div>
    );
  }

  closeDeleteConfirmPopup = () => {
    this.setState({ openDeleteConfirmPopup: false });
  };

  resetForm = () => {
    this.setState({ file: "", response: "", isLoading: false });
  };

  showAddCompany = () => {
    if (this.state.companyData.companyId) {
      this.setState({ companyOpen: true, company: this.state.companyData });
    } else {
      this.setState({ companyOpen: true, company: {} });
    }
  };
  closeAddCompanyPopup = () => {
    this.setState({ companyOpen: false, company: {} });
  };

  resetEmployeeField = () => {
    this.setState({
      isEmployeeEdit: false,
      employee: { empId: "", name: "", email: "" },
    });
  };

  render() {
    let {
      companyData,
      employee,
      showToast,
      toastMsg,
      openDeleteConfirmPopup,
      isEmployeeEdit,
    } = this.state;
    let { open } = this.props;
    console.log("");
    return (
      <div style={{ display: open ? "block" : "none" }}>
        <Snackbar
          style={{ bottom: "none", backgroundColor: "green" }}
          open={false}
          autoHideDuration={6000}
          message={toastMsg}
        />
        <div style={{ minHeight: "calc(100vh - 40px)" }}>
          <div className="row">
            <div
              className="column d-flex align-items-stretch"
              style={{ backgroundColor: "#fff" }}
            >
              <div style={{ width: "100%" }}>
                <div
                  className="addCompanyHeader"
                  style={{ display: "flex", margin: "0px" }}
                >
                  <div
                    style={{
                      marginTop: "-0.5rem",
                      marginLeft: "-2rem",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{ display: "inline-block", width: "10%" }}
                      className="genericUploaderBackIconCls"
                    >
                      <IconButton
                        aria-label="close"
                        style={{ width: "25px" }}
                        onClick={this.showCompanyList}
                      >
                        <img
                          src={backIcon}
                          style={{
                            width: "16px",
                            marginRight: "5px",
                            marginTop: "-5px",
                          }}
                        />
                      </IconButton>
                    </div>
                    <div
                      style={{
                        display: "inline-block",
                        width: "80%",
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {companyData.companyId != ""
                          ? companyData.company
                          : "Create Company"}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{ marginLeft: "1rem" }}>
                    <div>
                      <TextField
                        readOnly="true"
                        floatingLabelText="Company Name"
                        value={
                          companyData.companyId
                            ? companyData.companyId +
                              " - " +
                              companyData.company
                            : ""
                        }
                        style={{ width: "24rem" }}
                      />
                      {companyData.companyId != "" ? (
                        <FlatButton
                          style={{ marginLeft: "1rem" }}
                          disabled={!companyData.companyId}
                          onClick={this.showAddCompany}
                          className="flatButtonCls"
                        >
                          {" "}
                          Edit
                        </FlatButton>
                      ) : (
                        <FlatButton
                          style={{ marginLeft: "1rem" }}
                          onClick={this.showAddCompany}
                          className="flatButtonCls"
                        >
                          {" "}
                          Add{" "}
                        </FlatButton>
                      )}
                    </div>
                    <div>
                      <TextField
                        floatingLabelText="Employee Id"
                        value={employee.empId}
                        disabled={!companyData.companyId || isEmployeeEdit}
                        style={{ width: "24rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("empId", e.target.value)
                        }
                      />
                      <TextField
                        floatingLabelText="Name"
                        value={employee.name}
                        disabled={!companyData.companyId}
                        style={{ width: "24rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("name", e.target.value)
                        }
                      />
                      <TextField
                        floatingLabelText="Email"
                        value={employee.email}
                        disabled={!companyData.companyId}
                        style={{ width: "24rem" }}
                        onChange={(e) =>
                          this.onCompanyEmployeeValue("email", e.target.value)
                        }
                      />
                    </div>
                    {isEmployeeEdit ? (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          disabled={!companyData.companyId}
                          onClick={this.resetEmployeeField}
                          className="flatButtonCls"
                        >
                          Reset
                        </FlatButton>
                        <FlatButton
                          disabled={!companyData.companyId}
                          onClick={this.editEmployee}
                          className="flatButtonCls"
                          style={{ marginLeft: "5px" }}
                        >
                          <img src={addArrowIcon} /> Update
                        </FlatButton>
                      </div>
                    ) : (
                      <div style={{ float: "right", marginRight: "2rem" }}>
                        <FlatButton
                          disabled={!companyData.companyId}
                          onClick={this.addEmployee}
                          className="flatButtonCls"
                        >
                          <img src={addArrowIcon} /> Add
                        </FlatButton>
                      </div>
                    )}
                  </div>
                  <br />
                  <hr />
                  {this.renderEmployeeTable()}
                </div>
              </div>
            </div>
            <div className="column d-flex align-items-stretch rightMainDiv">
              <div>
                <Formsy.Form
                  ref="form"
                  onValidSubmit={this.submitNoteForm}
                  onInvalidSubmit={this.notifyFormError}
                >
                  <FormsyText
                    multiLine
                    name="note"
                    placeholder="Note..."
                    InputProps={{ disableUnderline: true }}
                    style={{
                      width: "93%",
                      marginLeft: "2rem",
                      marginBottom: "0",
                      height: "70px",
                      border: "1px solid #ccc",
                      padding: "10px",
                      marginTop: "0px",
                      maxHeight: "90px",
                    }}
                  />
                </Formsy.Form>
              </div>
              {this.renderContent()}
              <div
                style={{
                  float: "right",
                  marginTop: "1rem",
                  right: "30px",
                  bottom: "20px",
                }}
              >
                <FlatButton
                  disabled={this.state.isLoading}
                  onClick={this.resetForm}
                  className="flatButtonCls"
                >
                  Reset
                </FlatButton>
                <FlatButton
                  disabled={this.state.companyData.companyId ? false : true}
                  onClick={this.submitForm}
                  style={{ marginLeft: "2rem" }}
                  className="flatButtonCls"
                >
                  Submit
                </FlatButton>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          title="Delete User"
          open={openDeleteConfirmPopup}
          onRequestClose={this.closeDeleteConfirmPopup}
          style={{ width: "50%", textAlign: "center" }}
        >
          Are you sure you want to delete this user?
          <br />
          <br />
          <FlatButton
            type="button"
            className="flatButtonCls"
            onTouchTap={this.deleteConfirmPopupClick}
          >
            Yes
          </FlatButton>
          <FlatButton
            type="button"
            style={{ marginLeft: "2rem" }}
            className="flatButtonCls"
            onTouchTap={this.closeDeleteConfirmPopup}
          >
            No
          </FlatButton>
        </Dialog>
        <AddCompany
          open={this.state.companyOpen}
          token={this.props.token}
          company={this.state.company}
          closeAddCompanyPopup={this.closeAddCompanyPopup}
          updateCompanyData={this.updateCompanyData}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/documentUploader/ShowCompanyDetail.js